$(self).ready(() => {
  /**
   * accordion behavior for /faq page
   */
  if (document.body.classList.contains('page-template-page-faq')) {
    $('.js_faq-accordion-control').on('click', function () {
      $($(this).data('target')).toggleClass('--active')
      document.querySelector($(this).data('target')).scrollIntoView()
      window.scrollBy(0, -65)
    })
  }
})
